import React, { lazy } from 'react';
import { CATEGORIES, MENU_PRODUCTS } from '../data/menuData';
import { useLanguage } from '../context/LanguageContext';
interface CategoryGridProps {
  onSelectCategory: (category: string) => void;
}
const CATEGORY_ICONS: Record<string, string> = {
  Pizzas: '🍕',
  Bebidas: '🥤',
  Entradas: '🍤',
  Ensaladas: '🥗',
  Sopas: '🍲',
  'A la Parrilla': '🥩',
  Arroz: '🍚',
  Pastas: '🍝',
  Otros: '🍗',
  Postres: '🍰',
  Sandwich: '🥪',
  Adicionales: '➕'
};
const CATEGORY_DESCRIPTIONS: Record<string, string> = {
  Pizzas: 'Artesanales al horno de leña',
  Bebidas: 'Frías, calientes y especiales',
  Entradas: 'Para compartir',
  Ensaladas: 'Frescas y saludables',
  Sopas: 'Reconfortantes',
  'A la Parrilla': 'Cortes selectos Angus',
  Arroz: 'Salteados y especiales',
  Pastas: 'Con pan de ajo',
  Otros: 'Platos del chef',
  Postres: 'El toque dulce final',
  Sandwich: 'Rellenos y tostados',
  Adicionales: 'Complementá tu plato'
};
function getCategoryCount(category: string): number {
  return MENU_PRODUCTS.filter(p => p.category === category).length;
}
export function CategoryGrid({
  onSelectCategory
}: CategoryGridProps) {
  const {
    t,
    translateCategory
  } = useLanguage();
  // Split categories: first 2 are hero, rest are regular
  const heroCategories = CATEGORIES.slice(0, 2);
  const regularCategories = CATEGORIES.slice(2);
  return <div className="mb-6" data-id="element-1031">
      <h2 className="text-xl font-heading font-bold text-white mb-4 px-1 tracking-wide" data-id="element-1032">
        {t('whatDoYouCrave')}
      </h2>

      {/* Hero categories — full width, taller */}
      <div className="space-y-3 mb-3" data-id="element-1033">
        {heroCategories.map(category => {
        const firstProduct = MENU_PRODUCTS.find(p => p.category === category);
        const emoji = CATEGORY_ICONS[category] || '🍽️';
        const description = CATEGORY_DESCRIPTIONS[category] || '';
        const count = getCategoryCount(category);
        return <button key={category} onClick={() => onSelectCategory(category)} className="relative rounded-2xl overflow-hidden h-40 w-full text-left group active:scale-[0.98] transition-transform border border-gray-800" data-id="element-1034">
              {firstProduct?.image ? <img src={firstProduct.image} alt={category} className="absolute inset-0 w-full h-full object-cover" loading="lazy" data-id="element-1035" /> : <div className="absolute inset-0 bg-gradient-to-br from-surface-light to-surface" data-id="element-1036" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20" data-id="element-1037" />
              <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-1038">
                <div className="flex items-end justify-between" data-id="element-1039">
                  <div data-id="element-1040">
                    <span className="text-2xl mb-1 block" data-id="element-1041">{emoji}</span>
                    <h3 className="text-white font-heading font-bold text-xl leading-tight" data-id="element-1042">
                      {translateCategory(category)}
                    </h3>
                    {description && <p className="text-gray-400 text-xs mt-0.5" data-id="element-1043">
                        {description}
                      </p>}
                  </div>
                  <span className="text-xs text-gray-400 bg-black/40 backdrop-blur-sm rounded-full px-2.5 py-1 border border-gray-700/50" data-id="element-1044">
                    {count} opciones
                  </span>
                </div>
              </div>
            </button>;
      })}
      </div>

      {/* Regular categories — 2-column grid, shorter */}
      <div className="grid grid-cols-2 gap-3" data-id="element-1045">
        {regularCategories.map(category => {
        const firstProduct = MENU_PRODUCTS.find(p => p.category === category);
        const emoji = CATEGORY_ICONS[category] || '🍽️';
        const description = CATEGORY_DESCRIPTIONS[category] || '';
        const count = getCategoryCount(category);
        return <button key={category} onClick={() => onSelectCategory(category)} className="relative rounded-2xl overflow-hidden h-28 text-left group active:scale-[0.97] transition-transform border border-gray-800" data-id="element-1046">
              {firstProduct?.image ? <img src={firstProduct.image} alt={category} className="absolute inset-0 w-full h-full object-cover" loading="lazy" data-id="element-1047" /> : <div className="absolute inset-0 bg-gradient-to-br from-surface-light to-surface" data-id="element-1048" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" data-id="element-1049" />

              {/* Item count badge */}
              <div className="absolute top-2.5 right-2.5" data-id="element-1050">
                <span className="text-[10px] text-gray-400 bg-black/50 backdrop-blur-sm rounded-full px-2 py-0.5 border border-gray-700/40" data-id="element-1051">
                  {count}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-3" data-id="element-1052">
                <span className="text-lg mb-0.5 block" data-id="element-1053">{emoji}</span>
                <h3 className="text-white font-heading font-bold text-sm leading-tight" data-id="element-1054">
                  {translateCategory(category)}
                </h3>
                {description && <p className="text-gray-500 text-[10px] mt-0.5 leading-tight line-clamp-1" data-id="element-1055">
                    {description}
                  </p>}
              </div>
            </button>;
      })}
      </div>
    </div>;
}
;
'>';